var _g, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickCircleYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 83,
    height: 83,
    rx: 41.5,
    fill: "#FFF6E3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43.5,
    stroke: "#FFDA79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 33.75C39.124 33.75 34.75 38.124 34.75 43.5C34.75 48.876 39.124 53.25 44.5 53.25C49.876 53.25 54.25 48.876 54.25 43.5C54.25 38.124 49.876 33.75 44.5 33.75ZM44.5 51.75C39.951 51.75 36.25 48.049 36.25 43.5C36.25 38.951 39.951 35.25 44.5 35.25C49.049 35.25 52.75 38.951 52.75 43.5C52.75 48.049 49.049 51.75 44.5 51.75ZM45.5 39.5C45.5 40.052 45.052 40.5 44.5 40.5C43.948 40.5 43.5 40.052 43.5 39.5C43.5 38.948 43.948 38.5 44.5 38.5C45.052 38.5 45.5 38.948 45.5 39.5ZM45.25 43.5V47.5C45.25 47.914 44.914 48.25 44.5 48.25C44.086 48.25 43.75 47.914 43.75 47.5V43.5C43.75 43.086 44.086 42.75 44.5 42.75C44.914 42.75 45.25 43.086 45.25 43.5Z",
    fill: "#FFD35F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleYellow);
export default __webpack_public_path__ + "static/media/tick-circle-yellow.281092ad7c50ff6663f36c55a379f9ae.svg";
export { ForwardRef as ReactComponent };